export const STRIPE_AMOUNT = 'STRIPE_AMOUNT';
export const USER_BASE = 'USER_BASE';
